export default {
  SAVE_ACCOUNT: 'SAVE_ACCOUNT',
  CLEAR_ALL_DATA: 'CLEAR_ALL_DATA',
  SELECT_LIST_LANGUAGE: 'SELECT_LIST_LANGUAGE',
  SAVE_PROFILE: 'SAVE_PROFILE',
  CREATE_FCM: 'CREATE_FCM',
}
